import { axios } from "..";

export interface IReferral {
    legacyId?: number;
    referralDate?: number;
    sendById?: number;
    firmById?: number;
    sendToId?: number;
    firmToId?: number;
    detail?: string;
    estimatedFees: number;
    estimatedFeesDetail?: string;
    submissionDate: string;
    submittedByContact?: number;
    type: number;
    referralType: string;
    isDeleted?: boolean;
    relationshipType?: string;
    fromDate?: number;
    toDate?: number;
    firmByName?: string;
    firmToName?: string;
    sendToName?: string;
    sendByName?: string;
    createdDate?: number;
    id: string;
    firmByLogo?: string;
    firmToLogo?: string;
}

export const getFirmReferrals = async (firmId: number, limit: number = 100, sortOrder: 'asc' | 'desc' = 'desc'): Promise<IReferral[]> => {
    try {
        const params = new URLSearchParams({
            firmId: firmId.toString(),
            limit: limit.toString(),
            sortOrder: sortOrder
        });
        
        const response = await axios.Get(`/referral?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching firm referrals:', error);
        throw error;
    }
};
